export const cmpNamesSeparator = '|||';

export function getTRFXTreeDS(contextsList) {
  // const sorted = contextsList.sort((a, b) => {
  //   if (a.client < b.client) return -1
  //   if (a.client > b.client) return 1
  //   return 0
  // })
  if (!contextsList.contextFindMany) return [];
  const idByKey = {};
  const treeDS = contextsList.contextFindMany.reduce(
    (
      acc,
      {
        client,
        template,
        siteEdition,
        urls,
        _id,
        application,
        components,
        customerName,
      }
    ) => {
      if (
        !client ||
        !template ||
        !siteEdition ||
        !application ||
        !customerName
      ) {
        return acc;
      }

      // save client
      const clientKey = `${application}|||${client}`;
      let clientId = idByKey[clientKey];
      if (clientId === undefined) {
        // add client as node
        const clientNode = {
          id: acc.length,
          label: [
            customerName,
            `(${client.toString().toUpperCase()})`,
            `_${application.toString().toUpperCase()}`,
          ]
            .filter(Boolean)
            .join(' '),
          // c: client,
          // a: application,
          hasChildren: true,
        };
        acc.push(clientNode);
        clientId = clientNode.id;
        idByKey[clientKey] = clientId;
      }

      // save template
      const templateKey = `${application}|||${client}|||${template}`;
      let templateId = idByKey[templateKey];
      if (templateId === undefined) {
        // add client as node
        const templateNode = {
          id: acc.length,
          label: template,
          pId: clientId,
          // t: template,
          // a: application,
          // c: client,
          hasChildren: true,
        };
        acc.push(templateNode);
        templateId = templateNode.id;
        idByKey[templateKey] = templateId;
      }

      // save siteEdition
      const seKey = `${application}|||${client}|||${template}|||${siteEdition}`;
      let seId = idByKey[seKey];
      if (seId === undefined) {
        // add client as node
        const seNode = {
          id: acc.length,
          label: siteEdition.toString().toLowerCase(),
          pId: templateId,
          // a: application,
          // c: client,
          // t: template,
          // se: siteEdition,
          hasChildren: !!urls,
        };
        acc.push(seNode);
        seId = seNode.id;
        idByKey[seKey] = seId;
      }

      // save each url
      (urls || []).forEach((url) => {
        const cmpNames = [
          '',
          ...(components || []).map((c) =>
            c.name ? c.name.toString().trim() : ''
          ),
          '',
        ].join(cmpNamesSeparator);

        acc.push({
          id: acc.length,
          label: url,
          pId: seId,
          parentIds: [clientId, templateId, seId],
          il: true,
          a: application,
          c: client,
          t: template,
          se: siteEdition,
          cmps: components,
          cNames: cmpNames,
          cId: _id,
          url,
          selectedLabel: url,
        });
      });

      return acc;
    },
    []
  );
  return treeDS;
}

export function getAtcTreeDS(data) {
  if (!data.atcFeaturesFindMany) return [];
  const idByKey = {};
  const treeDS = data.atcFeaturesFindMany.reduce(
    (acc, { name, menuPath, _id, application }) => {
      if (!name || !menuPath || !_id || !application) {
        return acc;
      }
      // save application
      const applicationKey = `${application}`;
      let applicationId = idByKey[applicationKey];
      if (applicationId === undefined) {
        // add application as node
        const applicationNode = {
          id: acc.length,
          label: application.toString(),
          hasChildren: true,
        };
        acc.push(applicationNode);
        applicationId = applicationNode.id;
        idByKey[applicationKey] = applicationId;
      }

      // save menuPath
      // menuPath = <v1>/<v2>/<v3>
      // -application
      // --<v1>
      // ---<v2>
      // ----<v3>
      let currentPId = applicationId;
      const v1v2v3 = menuPath.toString().split('/');
      let currentKey = `${application}`;
      let currentId;
      const ids = [];
      v1v2v3.forEach((vi) => {
        currentKey += `|||${vi}`;
        currentId = idByKey[currentKey];

        if (currentId === undefined) {
          // add menuPath's Vi as node
          const menuPathCurrentNode = {
            id: acc.length,
            label: vi,
            pId: currentPId,
            hasChildren: true,
          };
          acc.push(menuPathCurrentNode);
          currentId = menuPathCurrentNode.id;
          idByKey[currentKey] = currentId;
        }
        ids.push(currentId);
        currentPId = currentId;
      });

      // save name
      const nameKey = `${currentKey}|||${name}`;
      let nameId = idByKey[nameKey];
      if (nameId === undefined) {
        // add name as node
        const nameNode = {
          id: acc.length,
          featureId: _id,
          label: name,
          pId: currentId,
          hasChildren: false,
          il: true,
          application,
          menuPath,
          name,
          parentIds: [applicationId, ...ids],
          selectedLabel: nameKey.replaceAll(`|||`, `/`),
        };
        acc.push(nameNode);
        nameId = nameNode.id;
        idByKey[nameKey] = nameId;
      }

      return acc;
    },
    []
  );
  return treeDS;
}

export const getTRFXTreeDS2 = (data) => {
  if (!data?.contextFindMany?.length) return [];

  let nodeId = 0;

  // Group by application -> client -> template -> siteEdition
  const applicationGroups = data.contextFindMany.reduce((acc, context) => {
    const {
      application,
      client,
      template,
      siteEdition,
      urls,
      _id,
      components,
      customerName,
    } = context;

    if (!application || !client || !template || !siteEdition || !customerName) {
      return acc;
    }

    if (!acc[application]) {
      acc[application] = {
        clients: {},
      };
    }

    if (!acc[application].clients[client]) {
      acc[application].clients[client] = {
        customerName,
        templates: {},
      };
    }

    if (!acc[application].clients[client].templates[template]) {
      acc[application].clients[client].templates[template] = {
        siteEditions: {},
      };
    }

    if (
      !acc[application].clients[client].templates[template].siteEditions[
        siteEdition
      ]
    ) {
      acc[application].clients[client].templates[template].siteEditions[
        siteEdition
      ] = {
        urls: [],
      };
    }

    if (urls?.length) {
      const cmpNames = [
        '',
        ...(components || []).map((c) =>
          c.name ? c.name.toString().trim() : ''
        ),
        '',
      ].join(cmpNamesSeparator);

      urls.forEach((url) => {
        acc[application].clients[client].templates[template].siteEditions[
          siteEdition
        ].urls.push({
          url,
          _id,
          components,
          cmpNames,
        });
      });
    }

    return acc;
  }, {});

  // Transform into PrimeReact Tree structure with sequential keys
  const treeData = Object.entries(applicationGroups).map(
    ([app, appData], appIndex) => ({
      key: appIndex.toString(),
      label: app,
      data: app,
      // id: nodeId++,
      icon: 'pi pi-folder',
      children: Object.entries(appData.clients).map(
        ([clientId, clientData], clientIndex) => ({
          key: `${appIndex}-${clientIndex}`,
          label: `${clientData.customerName} (${clientId.toUpperCase()})`,
          data: clientId,
          // id: nodeId++,
          icon: 'pi pi-folder',
          children: Object.entries(clientData.templates).map(
            ([templateId, templateData], templateIndex) => ({
              key: `${appIndex}-${clientIndex}-${templateIndex}`,
              label: templateId,
              data: templateId,
              // id: nodeId++,
              icon: 'pi pi-folder',
              children: Object.entries(templateData.siteEditions).map(
                ([seId, seData], seIndex) => ({
                  key: `${appIndex}-${clientIndex}-${templateIndex}-${seIndex}`,
                  label: seId.toLowerCase(),
                  data: seId,
                  // id: nodeId++,
                  icon: 'pi pi-folder',
                  children: seData.urls.map((urlData, urlIndex) => {
                    // const urlNodeId = nodeId++;
                    return {
                      key: `${appIndex}-${clientIndex}-${templateIndex}-${seIndex}-${urlIndex}`,
                      label: urlData.url,
                      data: urlData.url,
                      // id: urlNodeId,
                      info: {
                        url: urlData.url,
                        contextId: urlData._id,
                        isLeaf: true,
                        components: urlData.components.map((c) => c.name),
                        // cmpNames: urlData.cmpNames,
                        // app,
                        // client: clientId,
                        // template: templateId,
                        // siteEdition: seId,
                      },
                      icon: 'pi pi-file',
                      // selectable: true,
                    };
                  }),
                })
              ),
            })
          ),
        })
      ),
    })
  );
  return treeData;
};

/* Example output structure:
[
  {
    key: '0',
    label: 'Application1', 
    data: 'Application1',
    icon: 'pi pi-folder',
    children: [
      {
        key: '0-0',
        label: 'Client1',
        data: 'Client1', 
        icon: 'pi pi-folder',
        children: [
          {
            key: '0-0-0',
            label: 'Template1',
            data: 'Template1',
            icon: 'pi pi-folder',
            children: [
              {
                key: '0-0-0-0',
                label: 'siteedition1',
                data: 'SiteEdition1',
                icon: 'pi pi-folder',
                children: [
                  {
                    key: '0-0-0-0-0',
                    label: 'https://example.com/page1',
                    data: 'https://example.com/page1',
                    info: {
                      url: 'https://example.com/page1',
                      cId: '123',
                      il: true,
                      cmps: ['comp1', 'comp2'],
                      cNames: ['comp1', 'comp2'],
                      app: 'Application1',
                      c: 'Client1', 
                      t: 'Template1',
                      se: 'SiteEdition1'
                    },
                    icon: 'pi pi-file'
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
]
*/
